export default __webpack_public_path__ + "media/images/features/jtb/hero-sake-795223bec331e98415fb57da14640630.png";